/**
 * LaunchDarkly key: `DashboardRevamp`.
 * ON = new dashboard UI + multi-pack bootstrap (self-contained; not gated on `uiRevamp`).
 * OFF/absent = original Dashboard-v2.
 *
 * Checks both casings — the LD React SDK camelCases keys by default
 * (`dashboardRevamp`), while the dashboard key may arrive as `DashboardRevamp`.
 *
 * `uiRevamp` only selects the app shell (revamp header vs legacy ModelOverviewPage).
 * Nav/blocks revamp can be on for everyone while this flag rolls out the dashboard tab.
 */
export const isDashboardRevampEnabled = (flags?: {
  DashboardRevamp?: boolean;
  dashboardRevamp?: boolean;
}): boolean => Boolean(flags?.DashboardRevamp ?? flags?.dashboardRevamp);

export default isDashboardRevampEnabled;
